import { render, staticRenderFns } from "./ModalRegalo.vue?vue&type=template&id=1ec92cde"
import script from "./ModalRegalo.vue?vue&type=script&lang=js"
export * from "./ModalRegalo.vue?vue&type=script&lang=js"
import style0 from "./ModalRegalo.vue?vue&type=style&index=0&id=1ec92cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports